import { Component } from '@angular/core';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { InfoAccordionComponent } from '@app/shared/components/molecules/info-accordion/info-accordion.component';
import { IconNames } from '@app/shared/enums/icon-names';

@Component({
  selector: 'app-two-g-sunset-information',
  imports: [IceAlertComponent, InfoAccordionComponent],
  templateUrl: './two-g-sunset-information.component.html',
  styleUrl: './two-g-sunset-information.component.scss',
})
export class TwoGSunsetInformationComponent {
  IconNames = IconNames;
}
